import React from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { LiveTv, Score, Settings, Info } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LsLogo } from './assets/live-scoring-logo-secondary.svg';
import { ReactComponent as TbLogo } from './assets/tour-builder-logo-secondary.svg'

const HomePage = () => {

  const navigate = useNavigate(); // Initialize the navigate function

  return (
    <Box
      sx={{
        width: '90vh',
        maxWidth: '600px',
        height: '90vh',
        maxHeight: '600px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10,
        boxShadow: 20
      }}
    >
      <Stack
        direction="column"
        spacing={10}
        sx={{
          width: '100%',
          height: '100%'
        }}
      >
        <Stack 
          direction="row" 
          spacing={10}
          sx={{
            flex: 1,
            width: '100%'
          }}
        >
          <IconButton
            //onClick={() => navigate('/LiveScoring')}
            sx={{
              flex: 1,
              height: '100%',
              borderRadius: 5,
              backgroundColor: 'primary.light',
              '&:hover': {
                backgroundColor: 'primary.main'
              }
            }}
          >
            <Stack direction={'column'} alignItems={'center'} justifyContent={'center'} spacing={2} padding={1}>
              <LsLogo style={{ width: '70%', height: '70%' }} />
              <Typography variant='h6' sx={{ color: 'secondary.main'}}>Live Scoring</Typography>
            </Stack>
          </IconButton>
          
          <IconButton
            //onClick={() => navigate('/MomentCentral')}
            sx={{
              flex: 1,
              height: '100%',
              borderRadius: 5,
              backgroundColor: 'primary.light',
              '&:hover': {
                backgroundColor: 'primary.main'
              }
            }}
          >
            <Score sx={{ fontSize: '2rem' }} />
            <Typography variant='h6'>Moment Central</Typography>
          </IconButton>
        </Stack>

        <Stack 
          direction="row" 
          spacing={10}
          sx={{
            flex: 1,
            width: '100%'
          }}
        >
          <IconButton
            onClick={() => navigate('/TournamentBuilder')}
            sx={{
              flex: 1,
              height: '100%',
              borderRadius: 5,
              backgroundColor: 'primary.light',
              '&:hover': {
                backgroundColor: 'primary.main'
              }
            }}
          >
            <Stack direction={'column'} alignItems={'center'} justifyContent={'center'} spacing={2} padding={1}>
              <TbLogo style={{ width: '70%', height: '70%' }} />
              <Typography variant='h6' sx={{ color: 'secondary.main'}}>Tournament Builder</Typography>
            </Stack>
          </IconButton>
          
          <IconButton
            sx={{
              flex: 1,
              height: '100%',
              borderRadius: 5,
              backgroundColor: 'primary.light',
              '&:hover': {
                backgroundColor: 'primary.main'
              }
            }}
          >
            <Info sx={{ fontSize: '2rem' }} />
            <Typography variant='h6'>Score Caddy</Typography>
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default HomePage;
